<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'TechCategoryCenter',
            to: {
              name: 'TechCategoryCenter'
            }
          },
          {
            name: 'Create',
            to: {
              name: 'TechCategoryCreate',
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>新增技術類別</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 新增技術類別 -->
    <TechCategoryCreateEdit></TechCategoryCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import TechCategoryCreateEdit from '@/views/E-8__TechCategory/c/TechCategoryCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    TechCategoryCreateEdit,
  },
  computed: {
    ...mapState('technologycategory', ['technologycategory']),
  },
  created() {
    this.setTechnologyCategory({});
  },
  methods: {
    ...mapActions('technologycategory', ['setTechnologyCategory', 'save']),
    cancelHandler() {
      this.$router.push({ name: 'TechCategoryCenter' });
    },
    saveHandler() {
      this.errors = [];
      if (this.$refs.form.validate()) {
        if (!this.technologycategory.title) {
          this.errors.push('標題 required.');
        } else if (!this.technologycategory.bu_id) {
          this.errors.push('BU required.');
        } else if (!this.technologycategory.slug) {
          this.errors.push('Slug required.');
        }
        if (this.errors.length > 0) {
          /* eslint-disable */
          alert(this.errors);
          /* eslint-disable */
          return false;
        }
        this.save(this.technologycategory).then(() => {
          this.$router.push({ name: 'TechCategoryCenter' });
        });
      }
    },
  },
};
</script>
<style></style>
